// extracted by mini-css-extract-plugin
export default {"c-notification":"urTHO","exit-active":"jHWM9","enter":"PRq7x","enter-active":"qiYbA","c-notification__action":"hFVCj","notifications":"nAHt7"};